export const aciMagic = {
    iconName: 'magic',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 25' },
        path: {
            attr: {
                d: 'M7.724 7.735l3.254 1.005 2.37-1.96a.363.363 0 01.607.275l-.095 3.47 2.953 1.632a.381.381 0 01-.087.687l-3.228 1.155-1.156 3.229a.38.38 0 01-.686.086l-1.632-2.952-3.47.095a.363.363 0 01-.276-.608l1.961-2.37-1.005-3.254a.4.4 0 01.49-.49zM13.499 13.998L21 21.5M16.8 4.7h2.4M18 3.5v2.4M4.2 19.1h2.4M5.4 17.9v2.4M9.6 5.3V3.5M3 10.7h1.8',
                stroke: 'currentColor',
                'stroke-width': '1.2',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
            },
        },
    },
};
